import React, { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import moment from 'moment';
import OrderSummary from '../../dashboard/components/order-summary';
import PassbookService from '../../../services/passbook.service';
import Loader from '../../../shared/common/loader';
import {
  formatAmount,
  getPaymentMethodLabel,
  getTransactionName,
} from '../../../utils';
import '../styles.css';
import { userStore } from 'store/UserStore';

interface PropsType {
  walletData: any;
}

const WalletTransactions: React.FC<PropsType> = ({ walletData }) => {
  const [customer,user] = userStore((state: any) => [state.customer,state.user]);
  const [selectedWalletData, setSelectedWalletData] = useState<any>(null);
  const [isShow, setIsShow] = useState(false);
  const [loading, setLoading] = useState<any>(false);

  /**
   * Set selected wallet data
   * @param data
   */
  const onChangeWalletData = async (data) => {
    await getOrderDetails(data.extRefId);
  };

  /**
   * Change side modal state
   * @param value
   */
  const onHandleSideModal = (value) => {
    setIsShow(value);
  };

  /**
   * Get order details
   * @param orderRef
   */
  const getOrderDetails = async (orderRef) => {
    try {
      setLoading(true);
      const res: any = await PassbookService.getOrderDetails(orderRef,user?.userId);
      if (
        res.status === 200 &&
        res.data.data.result &&
        res.data.data.result.length > 0
      ) {
        setSelectedWalletData(res.data.data.result[0]);
        setLoading(false);
        onHandleSideModal(true);
      }
    } catch (e: any) {
      console.log(e.message);
    }
  };

  const checkAmount = (record: any) => {
    if (record.type == 'ORDER_SELL' && record.method == 'WALLET') {
      return '-';
    } else if (record.type == 'ORDER_SELL' && record.method == 'UPI') {
      return `+`;
    } else if (record.type == 'ORDER_SELL' && record.method == 'NEBK') {
      return `+`;
    }
    /// WALLET
    else if (
      (record.type == 'WALLET' && record.method == 'UPI') ||
      (record.type == 'WALLET' && record.method == 'NEBK')
    ) {
      return `+`;
    } else if (
      record.type == 'ORDER_BUYBACK' &&
      record.method == 'VERIFICATION'
    ) {
      return '+';
    } else if (
      record.type == 'ORDER_BUYBACK' &&
      record.method == 'ORDER_REFUND'
    ) {
      return '+';
    } else if (
      (record.type == 'ORDER_BUYBACK' && record.method == 'WALLET') ||
      (record.type == 'ORDER_BUYBACK' && record.method == 'NEFT')
    ) {
      return '+';
    } else if (record.type == 'WALLET' && record.method == 'NEFT') {
      return `-`;
    } else {
      return '';
    }

    // if('IN' === data.walletInOut){
    //   value = '+'
    // }else{
    //   value = '-'
    // }
    // if(data.type === 'ORDER_BUYBACK' || data.type === 'ORDER_REFUND'){
    //   value = '+'
    // }else if(data.type === 'ORDER_SELL'){
    //   value = '-'
    // }else if(data.type === 'WALLET'){
    //   if(data.method === 'NEFT'){
    //     value = '-'
    //   }else{
    //     value = '+'
    //   }
    // }else{
    //   value = ''
    // }
    // return value
  };

  const mapTypes = (data: any) => {
    var value;
    if (data.type === 'ORDER_SELL') {
      value = 'BUY';
    } else if (data.type === 'ORDER_BUYBACK') {
      value = 'SELL';
    } else {
      value = data.type;
    }
    return value;
  };

  const mapStatus = (data: any) => {
    switch (data) {
      case 'ACCEPTED':
        return 'APPROVED';
      case 'REJECTED':
        return 'REJECTED';
      case 'TRANSACTION_APPROVAL_PENDING':
        return 'APPROVAL PENDING';
      case 'TRANSACTION_VERIFICATION_PENDING':
        return 'VERIFICATION PENDING';
      default:
        return 'PENDING';
    }
  };

  return (
    <>
      {selectedWalletData && (
        <OrderSummary
          handleModal={onHandleSideModal}
          isShow={isShow}
          data={selectedWalletData}
          isPassbookRedirect={false}
          displaySummary={true}
          displayInvoice={
            customer?.customerCategory !== 'REGISTERED' ||
            selectedWalletData?.type !== 'BUYBACK'
          }
        />
      )}

      {loading && <Loader />}

      <Table className='mb-0' striped hover>
        <thead>
          <tr>
            <th>Transaction Id</th>
            {/* <th>Transaction Type</th> */}
            <th>Transaction</th>
            <th>Date</th>
            <th>Status</th>
            <th>Amount</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {walletData.length === 0 && (
            <tr>
              <td className='text-center' colSpan={6}>
                No wallet transactions available
              </td>
            </tr>
          )}
          {walletData.map((transaction: any, index: number) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={index}>
                <td className='min'>{transaction.transactionMasterId}</td>
                {/* <td>{mapTypes(transaction)}</td> */}
                <td>{getTransactionName(transaction)}</td>
                {/*getTransactionName(transaction)*/}
                <td className='min'>
                  {moment(transaction.date, ['DD-MM-YYYY hh:mm:ss']).format(
                    'DD-MMM-yyyy  hh:mm:ss A'
                  )}
                </td>
                <td>
                  <div className='badge bg-secondary'>
                    {mapStatus(transaction.status)}
                  </div>
                </td>
                <td className='min'>
                  ₹{' '}
                  {`${checkAmount(transaction)} ${formatAmount(
                    transaction.amount
                  )}`}
                </td>
                <td>
                  {(transaction.type === 'ORDER_SELL' ||
                    transaction.type === 'ORDER_BUYBACK') && (
                    <Button
                      variant='primary'
                      onClick={() => onChangeWalletData(transaction)}
                      bsPrefix='btn-table'
                      size='sm'
                    >
                      View
                    </Button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default WalletTransactions;
